import * as apiGET from '../api/get_apis'
import * as apiPOST from '../api/post_apis'
import * as actionType from '../actions/actionTypes';
import {temp_link} from "../settings/local";
import {ACTION_APPROVED} from "../actions/actionTypes";

// export const highlightActiveBlock = (blockId) => {
//     return {
//         type: actionType.BLOCK_IS_ACTIVE,
//         payload: blockId
//     }
// };

export const highlightActiveBlock = blockId => ({
    type: actionType.BLOCK_IS_ACTIVE,
    payload: blockId
});

export const hightlightActiveItem = itemId => ({
    type: actionType.ITEM_IS_ACTIVE,
    itemId
});


export const setDomainName = name => ({
    type: actionType.CURRENT_DOMAIN_NAME,
    name
});

// export const select = chapter => ({
//     type: actionType.CHAPTER_SELECTED,
//     payload: chapter
// });

export const select = (chapter) => {
    return {
        type: actionType.CHAPTER_SELECTED,
        payload: chapter
    }
};


export const contentLoaded = loaded => ({
    type: actionType.CONTENT_LOADING,
    loaded
});


export const selectItem = (item) => {
    return {
        type: actionType.ITEM_SELECTED,
        payload: item
    }
};

// export const selectItem = item => ({
//     type: actionType.ITEM_SELECTED,
//     payload: item
// });

export const setApproved = value => ({
    type: ACTION_APPROVED,
    value
});

export const getChapterList = (courseID, approved) => (dispatch, getState) => {
    dispatch({
        type: actionType.ACTION_GET_CHAPTER_LIST_STARTED
    });
    apiGET.getCourseStructure(courseID, approved)
        .then(
            response => {
                if (response.status === 401) {
                    // window.location.href = "http://mbook.kz/en/accounts/login/";
                } else if (response.status !== 200) {
                    dispatch({
                        type: actionType.ACTION_GET_CHAPTER_LIST_FAILED
                    });
                } else {
                    response.text().then(
                        value => {
                            const responseObject = JSON.parse(value);
                            dispatch({
                                type: actionType.ACTION_GET_CHAPTER_LIST_SUCCEEDED,
                                chapterList: responseObject

                            })
                        }
                    );

                }
            }
        )
        .catch(
            (e) => {
                console.log("This is chapter error ", e)
            }
        );
};

export const getTest = (itemPK, everyone = false) => (dispatch) => {
    dispatch({
        type: actionType.ACTION_GET_TEST_STARTED
    });
    apiGET.getTest(itemPK, everyone)
        .then(
            response => {
                if (response.status === 401) {
                    // window.location.href = "http://mbook.kz/en/accounts/login/";
                } else if (response.status !== 200) {
                    dispatch({
                        type: actionType.ACTION_GET_TEST_FAILED
                    })
                } else {
                    response.text().then(
                        value => {
                            const responseObject = JSON.parse(value);
                            dispatch({
                                type: actionType.ACTION_GET_TEST_SUCCEEDED,
                                testJSON: responseObject
                            })
                        }
                    );
                }
            }
        ).catch(
        (e) => {
            console.log(e)
        }
    );

};

// export const loadPage = link => dispatch => {
//     dispatch({type: actionType.CONTENT_LOADING, loaded: false});
//     apiGET.getPage(link)
//         .then(response => {
//
//             if (!response.ok) {
//                 throw Error(response.statusText);
//             }
//
//             return response;
//         })
//         .then(response => response.text())
//         .then(content => dispatch({
//             type: actionType.CONTENT_LOADED,
//             content
//         }))
//         .catch(error => console.log("This is error", error));
// };

export const postFeedback = (data) => dispatch => {
    apiPOST.postFeedback(data)
        .then(data => data.json())
        .then(data => console.log("This is data"))
        .catch(e => console.log("This is error"));
};

export const postTestResults = (data, everyone = false) => (dispatch) => {
    apiPOST.postTestResults(data, everyone)
        .then(
            response => {
                if (response.status === 401) {
                    // window.location.href = "http://mbook.kz/en/accounts/login/";
                } else if (response.status !== 200) {
                    dispatch({
                        type: actionType.ACTION_POST_TEST_FAILED
                    })
                } else {
                    response.text().then(
                        value => {
                            const responseObject = JSON.parse(value);
                            // console.log("This is response object", responseObject);
                            dispatch({
                                type: actionType.ACTION_POST_TEST_SUCCEEDED,
                                data: responseObject
                            })
                        }
                    )
                }
            }
        ).catch(
        (e) => {
            console.log(e)
        }
    );

};

export const setItemView = (data) => dispatch => {
    // console.log("This is sending data", data);
    apiPOST.postItemView(data)
        .then(response => {

            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then(response => response.text())
        .then(
            content => {
                // console.log("This is response ", content);
                // dispatch({
                //     type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
                //     link: link,
                //     content: content
                // })
            }
        )
        .catch(error => console.log("This is of next item content", error));
};

export const setAnimView = (data) => dispatch => {
    // console.log("This is sending data", data);
    apiPOST.postAnimationView(data)
        .then(response => {

            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then(response => response.text())
        .then(
            content => {
                // console.log("This is response ", content);
                // dispatch({
                //     type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
                //     link: link,
                //     content: content
                // })
            }
        )
        .catch(error => console.log("This is of next item content", error));
};

export const setChapter = allElements => ({
    type: actionType.CONTENT_CHAPTERS,
    allElements
});

export const getElementsOfChapter = (nodeId, allElements) => (nodeId ? allElements.filter(chapter => chapter.nodeId === parseInt(nodeId)) : allElements);

export const getItem = (itemId, elementsOfChapter) => (itemId ? elementsOfChapter.filter(item => item.item_id === parseInt(itemId))[0] : elementsOfChapter[0] ? elementsOfChapter[0] : {});

export const setCurrentElement = (nodeId, itemId, allElements) => dispatch => {
    let item, elementsOfChapter, indexOfItem, itemInNode, elementsOfParent;
    if (allElements.length > 0) {
        elementsOfChapter = getElementsOfChapter(nodeId, allElements);
        item = getItem(itemId, elementsOfChapter);
        itemInNode = elementsOfChapter.indexOf(item);
        indexOfItem = allElements.indexOf(item);
        if (item == null && nodeId) {
            item = allElements.filter(item => parseInt(item.parentNodeId) === parseInt(nodeId))[0];
            itemInNode = 0;
            indexOfItem = allElements.indexOf(item) - 1;
        }
        if (allElements.length - 2) {
            dispatch(nextElement(allElements[indexOfItem + 1], itemInNode));
        }
        if (indexOfItem > 0) {
            dispatch(previousElement(allElements[indexOfItem - 1], itemInNode));
        } else {
            dispatch(previousElement(null, itemInNode));
        }
        if (item) {
            if (item && item.content_type && item.content_type === 1 || item.content_type === 5) {
                dispatch(loadNextItems(nodeId, itemId, allElements));
            }

            if (item && item.content_type && item.item_exec_file.length > 0
            ) {
                dispatch({
                    type: actionType.ITEM_SELECTED,
                    payload: item
                });
            } else if (item && item.content_type && item.content_type === 4) {
                dispatch(getTest(item.item_pk))
            }
        }

    }
};


export const loadNextItems = (nodeId, itemId, allElements) => dispatch => {
    let elementsOfChapter, itemInNode, indexOfItem, item;
    elementsOfChapter = getElementsOfChapter(nodeId, allElements);
    item = getItem(itemId, elementsOfChapter);
    itemInNode = elementsOfChapter.indexOf(item);
    indexOfItem = allElements.indexOf(item);
    let link;
    if (item) {
        link = item.item_exec_file;
        // } else
        //     if (item.item_exec_file === "/media/46/items/49/index.html ") {
        //     link = "http://mbook.kz/" + item.item_exec_file;
    } else {
        link = "";
    }

    if (link) {
        apiGET.getPage(link)
            .then(response => {

                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then(response => response.text())
            .then(
                content => {
                    dispatch({
                        type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
                        item: item,
                        itemInNode,
                        content: content
                    });
                    if (indexOfItem < allElements.length - 1) {
                        let item;
                        for (let i = indexOfItem; i < allElements.length; i++) {
                            item = allElements[i];
                            if (item && item.content_type && item.content_type === 1 || item.content_type === 5) {
                                item = allElements[indexOfItem + 1];
                                const {nodeId, item_id} = item;
                                loadNextItems(nodeId, item_id, allElements);
                            }
                        }
                    }
                }
            )
            .catch(error => console.log("This is of next item content", error));
    } else if (link.length < 1) {
        let item = {};
        item.item_exec_file = "no_file";
        dispatch({
            type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
            item: item,
            itemInNode,
            content: 'homescreen on Android'
        })
    }
};


export const loadContent = (item, itemInNode) => dispatch => {
    let link;
    // link = temp_link + item.item_exec_file;
    if (item) {
        // link = "http://mbook.kz/media/46/items/2/index.html";
        link = item.item_exec_file;
    } else {
        link = "";
    }
    // link = "http://mbook.kz/media/46/items/49/index.html";
    if (link) {
        apiGET.getPage(link)
            .then(response => {

                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then(response => response.text())
            .then(
                content => {
                    dispatch({
                        type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
                        item: item,
                        itemInNode,
                        content: content
                    })
                }
            )
            .catch(error => console.log("This is of next item content", error));
    } else if (link.length < 1) {
        let item = {};
        item.item_exec_file = "no_file";
        dispatch({
            type: actionType.CHAPTER_CONTENT_LOADED_SUCCESS,
            item: item,
            itemInNode,
            content: 'homescreen on Android'
        })
    }
};


export const previousElement = (item, itemInNode) => dispatch => {
    if (item && (item.content_type === 1 || item.content_type === 6)) {
        dispatch(loadContent(item, itemInNode))
    }
    // if (item !== null) {
    return dispatch({
        type: actionType.PREVIOUS_ITEM,
        item,
        itemInNode
    })
    // }
};

export const nextElement = (item, itemInNode) => dispatch => {
    if (item && (item.content_type === 1 || item.content_type === 6)) {
        dispatch(loadContent(item, itemInNode));
    }
    return dispatch({
        type: actionType.NEXT_ITEM,
        item,
        itemInNode
    })
};

export const postExamResult = (data) => (dispatch) => {
    apiPOST.postExamResult(data)
        .then(response => console.log("this is response", response))
        .catch(e => console.log("This is exam exception", e));
};


export const openNavBar = buttonClosed => ({
    type: actionType.CLOSE_BUTTON,
    buttonClosed
});

export const closeNavigation = () => ({
    type: actionType.CLOSE_BUTTON,
    buttonClosed: false
});

export const closeNavBar = () => ({
    type: actionType.CLOSE_NAV_BAR
});



// WEBPACK FOOTER //
// ./src/actions/index.js